import $ from 'jquery';
import slick from 'slick-carousel';
import matchHeight from 'jquery-match-height'
import { Fancybox } from "@fancyapps/ui";


$(window).on('load', function () {

  Fancybox.bind("[data-fancybox]", {
    // Your custom options
  });

  $('.event-offer-slider .slide-text').matchHeight();

  $('.events-offers').each(function () {
    let controls = $(this).find('.controls');
    let slider = $(this).find('.event-offer-slider');

    slider.slick({
      rows: 0,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: controls.find('.prev'),
      nextArrow: controls.find('.next'),
      responsive: [
        {
          breakpoint: 640,
          settings: {
            adaptiveHeight: true
          }
        }
      ]

    });
  })

  $('.news').each(function () {
    let controls = $(this).find('.controls');
    let slider = $(this).find('.news-slider');

    slider.on('init', function () {
      $('.news-slide .text').matchHeight();
    })

    slider.slick({
      rows: 0,
      infinite: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      prevArrow: controls.find('.prev'),
      nextArrow: controls.find('.next'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
  })

  $('.gallery').each(function () {
    let gallery = $(this);
    let toggle = gallery.find('.toggle');
    if (toggle.length > 0) {
      toggle.on('click', function () {
        let span = $(this).find('span')
        span.text(span.text() == 'Show More' ? 'Show Less' : 'Show More');
        gallery.find('.hide').fadeToggle(300);
      })
    }

    let slider = gallery.find('.logo-slider');
    let controls = $(this).find('.controls');
    if (slider.length > 0) {
      slider.slick({
        rows: 0,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        prevArrow: controls.find('.prev'),
        nextArrow: controls.find('.next'),
        responsive: [
          {
            breakpoint: 1280,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 501,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      });
    }
  });

})